<template>
  <div class="flex justify-content-between align-items-center bg-white p-3 border-round shadow-1 mb-2 mr-2">
    <div class="flex align-items-center gap-3">
      <ZapiBackButton />
      <div class="flex align-items-center gap-2">
        <!-- Imagen de Logo dinámico desde la Empresa -->
        <img v-if="empresa && empresa.logo" :src="'data:image/png;base64, ' + empresa.logo" alt="Logo Empresa" style="height: 38px; border-radius: 4px;" />
        <span class="text-3xl zapi-font zapi-text-red font-bold ml-2">POS</span>
      </div>
      <ZapiBadgePill :label="nombreSucursal" severity="danger" />
    </div>

    <div class="flex align-items-start justify-content-end w-full gap-2">
      <ZapiSearchBar 
      :modelValue="busqueda" 
      :suggestions="suggestions" 
      @complete="$emit('buscarProducto', $event)"
      @update:modelValue="$emit('update:busqueda', $event)"
    />
    </div>
  </div>
</template>

<script>
import ZapiBadgePill from '../atoms/ZapiBadgePill.vue';
import ZapiSearchBar from '../molecules/ZapiSearchBar.vue';
import ZapiBackButton from '../atoms/ZapiBackButton.vue';
import EmpresaService from '@/service/EmpresaService';

export default {
  name: 'ZapiHeader',
  components: { ZapiBadgePill, ZapiSearchBar, ZapiBackButton },
  props: {
    busqueda: { type: [String, Object], default: null },
    suggestions: { type: Array, default: () => [] },
    nombreSucursal: { type: String, default: 'Desconocida' }
  },
  emits: ['update:busqueda', 'buscarProducto', 'reportarMerma'],
  data() {
    return {
      empresa: {}
    }
  },
  beforeCreate() {
    this.empresaService = new EmpresaService();
    this.empresaService.getFirstEmpresa().then((response) => {
      this.empresa = response.data;
    }).catch(e => console.error("Error cargando logo empresa:", e));
  }
}
</script>